export default "__VITE_ASSET__DEy0sBOr__"